import { Text, UseDisclosureReturn, VStack } from "@chakra-ui/react";
import React from "react";
import { deleteGroups } from "../../../../store/actions/deleteGroups";
import { ConfirmActionModal } from "../../../modals/ConfirmActionModal";

export function DeleteSelectedTransactionsModal({
  accountId,
  selectedCount,
  selectedIds,
  disclosure,
  clearSelected,
}: {
  accountId: string;
  selectedCount: number | undefined;
  selectedIds: string[];
  disclosure: UseDisclosureReturn;
  clearSelected: () => void;
}): React.ReactElement {
  const isSingleTransaction = selectedCount === 1;

  const deleteSelectedTransactions = async () => {
    await deleteGroups({
      accountId,
      groupIds: selectedIds,
    });

    clearSelected();
  };

  return (
    <ConfirmActionModal
      disclosure={disclosure}
      title={
        isSingleTransaction ?
          "Delete selected transaction?"
        : "Delete selected transactions?"
      }
      confirmButtonText="Delete"
      colorScheme="red"
      onConfirm={deleteSelectedTransactions}
    >
      <VStack alignItems="flex-start" spacing={4}>
        {isSingleTransaction ?
          <Text>
            This will delete the selected transaction from this account.
          </Text>
        : <Text>
            This will delete{" "}
            <Text as="span" fontWeight="bold">
              {selectedCount?.toLocaleString()}
            </Text>{" "}
            selected transactions from this account.
          </Text>
        }

        <Text color="gray.600">
          After deleting,{" "}
          {isSingleTransaction ? "this transaction" : "these transactions"} will
          need to be imported again or added manually if you need{" "}
          {isSingleTransaction ? "it" : "them"} later.
        </Text>
      </VStack>
    </ConfirmActionModal>
  );
}
